module.exports = __webpack_public_path__ + "img/google_play.30ee7bd4.png";